import {
  ActionReducerMapBuilder,
  AsyncThunk,
  PayloadAction,
} from '@reduxjs/toolkit';
import { WalletPayloadAction } from '../store/features/wallet';

export const addPendingAndErrorExtraReducers = <T, U, V, Z>(
  builder: ActionReducerMapBuilder<T>,
  thunk: AsyncThunk<U, V, Z>,
  key: keyof T
) => {
  builder.addCase(thunk.pending, (state) => {
    state[`${String(key)}RequestStatus`] = 'loading';
  });
  builder.addCase(thunk.rejected, (state, action) => {
    state[`${String(key)}Error`] = action.payload || 'GENERIC_ERROR';
    state[`${String(key)}RequestStatus`] = 'failed';
  });
};

export const addAllBasicExtraReducers = <T, U, V, Z>(
  builder: ActionReducerMapBuilder<T>,
  thunk: AsyncThunk<U, V, Z>,
  key: keyof T
) => {
  addPendingAndErrorExtraReducers(builder, thunk, key);
  builder.addCase(thunk.fulfilled, (state, action) => {
    state[`${String(key)}RequestStatus`] = 'succeeded';
    state[String(key)] = action?.payload;
  });
};

export const addWalletPendingAndErrorExtraReducers = <T, U, V, Z>(
  builder: any,
  thunk: AsyncThunk<U, V, Z>,
  key: string,
  condition: <X>(action: PayloadAction<WalletPayloadAction<X>>) => boolean
) => {
  builder.addCase(thunk.pending, (state, { meta }) => {
    if (
      condition === undefined ||
      condition({ type: null, payload: { ...meta } })
    ) {
      state[`${key}RequestStatus`] = 'loading';
    }
  });
  builder.addCase(
    thunk.rejected,
    (state, action: PayloadAction<WalletPayloadAction<T>>) => {
      if (condition(action)) {
        state[`${key}Error`] = action.payload.payload || 'GENERIC_ERROR';
        state[`${key}RequestStatus`] = 'failed';
      }
    }
  );
};

export const addAllWalletBasicExtraReducers = <T, U, V, Z>(
  builder: any,
  thunk: AsyncThunk<U, V, Z>,
  key: string,
  condition: <X>(action: PayloadAction<WalletPayloadAction<X>>) => boolean
) => {
  addWalletPendingAndErrorExtraReducers(builder, thunk, key, condition);
  builder.addCase(
    thunk.fulfilled,
    (state, action: PayloadAction<WalletPayloadAction<T>>) => {
      if (condition(action)) {
        state[`${key}RequestStatus`] = 'succeeded';
        state[key] = action?.payload.payload;
      }
    }
  );
};
